import React, { useContext, useEffect, useState } from "react";
import css from "../css/Mywallet.module.css";
import Rightcontainer from "../Components/Rightcontainer";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import socket from "../Components/socket";
import { AiOutlineHistory, AiOutlinePlus } from "react-icons/ai";
import { BsWallet2 } from "react-icons/bs";
import io from "../Components/socket";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { VscReferences } from "react-icons/vsc";

const Mywallet = ({ user }) => {
  const access_token = localStorage.getItem("token");

  const translations = {
    hi: {
      wallet: "वॉलेट",
      history: "इतिहास देखे | ",
      amount: "पैसे जोड़ें | ",
      withdraw: "पैसे निकाले  | ",
      referPerson: "रेफ़रल | ",
    },
    en: {
      wallet: "My Wallet",
      history: "Order History",
      amount: "Add Cash",
      withdraw: "Withdraw",
      referPerson: "Referral",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const theme = localStorage.getItem("theme");

  const styles = {
    backgroundColor: theme === "light" ? "#fff" : "#000",
    color: theme === "light" ? "black" : "#fff",
  };

  return (
    <>
      <div
        className="leftContainer pt-1 mt-3 mb_space"
        style={{ ...styles, height: "100vh" }}
      >
        <div className="wallet-page-container">
          <div className="wallet-header">
            <h3 className="section-title">My Balance</h3>
            <div className="total-balance-badge">
              Total: ₹{user && user.Wallet_balance}
            </div>
          </div>

          <div className="wallet-grid">
            {/* Deposit Card */}
            <div className="balance-card deposit-card">
              <div className="card-top">
                <div className="icon-bg">
                  <img src="/images/deposit.png" alt="Deposit" />
                </div>
                <div className="label-group">
                  <span className="balance-label">Deposit Cash</span>
                  <div className="amount-wrapper">
                    <img
                      src="/images/rupee.png"
                      className="rupee-symbol"
                      alt="₹"
                    />
                    <span className="amount-value text-deposit">
                      {user && user.Wallet_balance - user.withdrawAmount}
                    </span>
                  </div>
                </div>
              </div>
              <div className="card-actions">
                <Link className="action-link" to="/addcase">
                  <button className="btn-modern btn-deposit">
                    <AiOutlinePlus className="btn-icon" />
                    {translations[language].amount}
                  </button>
                </Link>
              </div>
            </div>

            {/* Winning Card */}
            <div className="balance-card winning-card">
              <div className="card-top">
                <div className="icon-bg">
                  <img src="/images/win-cash.png" alt="Winning" />
                </div>
                <div className="label-group">
                  <span className="balance-label">Winning Cash</span>
                  <div className="amount-wrapper">
                    <img
                      src="/images/rupee.png"
                      className="rupee-symbol"
                      alt="₹"
                    />
                    <span className="amount-value text-winning">
                      {user && user.withdrawAmount}
                    </span>
                  </div>
                </div>
              </div>
              <div className="card-actions">
                <Link className="action-link" to="/Withdrawopt">
                  <button className="btn-modern btn-winning">
                    <BsWallet2 className="btn-icon" />
                    {translations[language].withdraw}
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="rightContainer">
          <div>
            <Rightcontainer />
          </div>
        </div>
      </div>
    </>
  );
};
export default Mywallet;
